import {
  callBackAndSendAlert,
  callBackAndSendNotice,
  reloadAndSendAlert,
  reloadAndSendNotice,
  sendAlert,
  sendNotice,
} from '../controllers/noti_controller';

window.$sendAlert = (msg) => {
  sendAlert(msg);
};

window.$sendNotice = (msg) => {
  sendNotice(msg);
};

window.$reloadAndSendAlert = (msg) => {
  reloadAndSendAlert(msg);
};

window.$reloadAndSendNotice = (msg) => {
  reloadAndSendNotice(msg);
};

window.$_callBackAndSendNotice = (callback, msg) => {
  callBackAndSendNotice(callback, msg);
};

window.$_callBackAndSendAlert = (callback, msg) => {
  callBackAndSendAlert(callback, msg);
};
